export const consentPolicyKeys = {
  componentNameKey: 'CookieConsent_Dataset_Component_HtmlComponent',
  componentNameDefault: 'Html Component',
};
